import { render, staticRenderFns } from "./AddBuddycomCallUser.vue?vue&type=template&id=48a5fb50&scoped=true"
import script from "./AddBuddycomCallUser.vue?vue&type=script&lang=js"
export * from "./AddBuddycomCallUser.vue?vue&type=script&lang=js"
import style0 from "./AddBuddycomCallUser.vue?vue&type=style&index=0&id=48a5fb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a5fb50",
  null
  
)

export default component.exports